<template>
<div>
  <label class="font-weight-bold d-block mb-1">{{ label }}</label>
  <div class="d-flex flex-wrap align-items-center">
    <b-btn v-for="s in suggestions" :key="s.value" size="sm" class="mr-2 mb-2"
      :variant="value === s.value ? 'primary' : 'outline-primary'" @click="$emit('input', s.value)">{{ s.text }}</b-btn>
    <b-form-input type="date" size="sm" class="mb-2" style="max-width: 170px" :value="value" :min="min" :max="max"
      aria-label="Pick another date" @input="$emit('input', $event)"></b-form-input>
  </div>
</div>
</template>

<script>
// Date picker with one-tap suggestions (e.g. Dec 1).
export default {
  props: { value: String, label: String, min: String, max: String, suggestions: Array }
}
</script>
